import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f71bfdba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-section" }
const _hoisted_2 = { class: "background" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "title-en" }
const _hoisted_5 = { class: "title-cn" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.titleEn), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.titleCn), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.description), 1),
        _createVNode(_component_default_button, {
          textBtn: _ctx.textBtn,
          backgroundColor: _ctx.backgroundColorBtn,
          path: _ctx.path
        }, null, 8, ["textBtn", "backgroundColor", "path"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: _ctx.banner,
          class: "image"
        }, null, 8, _hoisted_8)
      ])
    ])
  ]))
}